import { A11yModule } from '@angular/cdk/a11y';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { GlobalModule } from '@app/core/global.module';
import { CropperDialogModule } from '@app/dialogs-helper/cropper-dialog/cropper-dialog.module';
import { CryptoProCertificateTableModule } from '@app/dialogs-helper/crypto-pro-certificate-table/crypto-pro-certificate-table.module';
import { ImagesDialogModule } from '@app/dialogs-helper/images-dialog/images-dialog.module';
import { MapDialogModule } from '@app/dialogs-helper/map-dialog/map-dialog.module';
import { TreeSelectDialogModule } from '@app/dialogs-helper/tree-select-dialog/tree-select-dialog.module';
import { AngularEditorModule } from '@components/angular-editor/angular-editor.module';
import { ButtonModule } from '@components/button/modules/button.module';
import { EmojiPickerComponent } from '@components/emoji-picker/emoji-picker.component';
import { EmojiPickerService } from '@components/emoji-picker/emoji-picker.service';
import { AutocompletePositionDirective } from '@directives/autocomplete-position/autocomplete-position.directive';
import { RestrictInputDirective } from '@directives/restrict-input/restrict.input.directive';
import { FuiCheckboxComponent, FuiIconComponent, FuiTooltipDirective } from '@fui/fui-components';
import { FactorDataHttpService } from '@modules/factor/services/factor-data-http.service';
import { FileUploadModule } from 'ng2-file-upload';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SkeletonDirectiveModule } from '../../../shared/directives/skeleton/skeleton-directive.module';
import { AddressComponent } from './address/component/address.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { ColorComponent } from './color/color.component';
import { DateMonthComponent } from './date-month/date-month.component';
import { DateRangeDDMMComponent } from './date-range-dd-mm/date-range.component';
import { DateRangeComponent } from './date-range/date-range.component';
import { DateTimeComponent } from './date-time/date-time.component';
import { DateYearComponent } from './date-year/date-year.component';
import { DateComponent } from './date/date.component';
import { DayMonthHeaderComponent } from './day-month/day-month-header/day-month-header.component';
import { DayMonthComponent } from './day-month/day-month.component';
import { DynamicFieldDirective } from './dynamic-field/dynamic-field.directive';
import { EmojiComponent } from './emoji/emoji.component';
import { InputTreeSelectComponent } from './input-tree-select/input-tree-select.component';
import { InputComponent } from './input/input.component';
import { MonthComponent } from './month/month.component';
import { RadioButtonComponent } from './radio-button/radio-button.component';
import { SelectSearchComponent } from './select-search/select-search.component';
import { SelectModule } from './select/select.module';
import { SlideToggleComponent } from './slide-toggle/slide-toggle.component';
import { SliderComponent } from './slider/slider.component';
import { TextComponent } from './text/text.component';
import { WysiwygComponent } from './wysiwyg/wysiwyg.component';

@NgModule({
    declarations: [
        InputComponent,
        DateComponent,
        RadioButtonComponent,
        CheckboxComponent,
        DynamicFieldDirective,
        SelectSearchComponent,
        TextComponent,
        WysiwygComponent,
        AddressComponent,
        InputTreeSelectComponent,
        DateMonthComponent,
        DateYearComponent,
        ColorComponent,
        EmojiComponent,
        DateRangeComponent,
        DateTimeComponent,
        MonthComponent,
        SliderComponent,
        SliderComponent,
        SlideToggleComponent,
        DayMonthHeaderComponent,
        DayMonthComponent,
        DateRangeDDMMComponent,
    ],
    imports: [
        GlobalModule,
        ReactiveFormsModule,
        FormsModule,
        TreeSelectDialogModule,
        CropperDialogModule,
        FileUploadModule,
        ColorPickerModule,
        EmojiPickerComponent,
        CryptoProCertificateTableModule,
        MatSliderModule,
        AngularEditorModule,
        MatSlideToggleModule,
        A11yModule,
        NgxSkeletonLoaderModule,
        SkeletonDirectiveModule,
        ButtonModule,
        RestrictInputDirective,
        ScrollingModule,
        AutocompletePositionDirective,
        ImagesDialogModule,
        MapDialogModule,
        FuiCheckboxComponent,
        FuiIconComponent,
        FuiTooltipDirective,
    ],
    providers: [FactorDataHttpService, EmojiPickerService],
    exports: [
        InputComponent,
        SelectModule,
        DateComponent,
        RadioButtonComponent,
        CheckboxComponent,
        DynamicFieldDirective,
        SelectSearchComponent,
        TextComponent,
        WysiwygComponent,
        AddressComponent,
        InputTreeSelectComponent,
        DateMonthComponent,
        DateYearComponent,
        DateRangeComponent,
        DateTimeComponent,
        DayMonthComponent,
        ColorComponent,
        EmojiComponent,
        MonthComponent,
        DayMonthHeaderComponent,
    ],
})
export class DynamicFieldsModule {}
